import { Socket, type Channel } from "phoenix";
import { getAccessToken } from "./auth";

const WS_URL = (import.meta.env.VITE_WS_URL as string | undefined) ?? "ws://localhost:4100/socket";

let socketInstance: Socket | null = null;

export async function connectSocket(): Promise<Socket> {
  const token = await getAccessToken();
  if (!token) throw new Error("Sin sesión");

  if (socketInstance && socketInstance.isConnected()) {
    socketInstance.disconnect();
  }

  socketInstance = new Socket(WS_URL, { params: { token } });
  socketInstance.connect();
  return socketInstance;
}

export function disconnectSocket() {
  socketInstance?.disconnect();
  socketInstance = null;
}

export function joinTracesStream(
  socket: Socket,
  org_id: string,
  filters: Record<string, unknown>
): Channel {
  return socket.channel(`traces:stream:${org_id}`, filters);
}

export function joinServicesStatus(socket: Socket, org_id: string): Channel {
  return socket.channel(`services:status:${org_id}`, {});
}

export function joinIncidentsStream(socket: Socket, org_id: string): Channel {
  return socket.channel(`incidents:${org_id}`, {});
}

export function joinIngestLag(socket: Socket, org_id: string): Channel {
  return socket.channel(`ingest:lag:${org_id}`, {});
}
